<template>

    <bottom-sheet ref="bottomsheet" :selfClose="true">

        <div class="bsfn__container">

            <img src="/img/bottomsheet/success.svg">

            <h1 class="bsfn__title">{{ $t('settings_notifications_notifications_disabled') }}</h1>

            <p class="bsfn__subtitle">{{ $t('settings_notifications_description_notifs_web') }}</p>

            <button class="btn btn-blue bsfn__btn-accept" @click="ctaToLink">{{ $t('settings_notifications_global_switch') }}</button>

        </div>

    </bottom-sheet>

</template>

<script>

import {configuration} from '../../../configuration'

import I18n from '@/modules/i18n'

import BottomSheet from '@/components/bottomSheet/BottomSheet'

export default {

    name: 'bottom-sheet-not-granted',

    components: {BottomSheet},

    data() {
        return {
            show: false
        }
    },

    methods: {

        open() {
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        ctaToLink() {

            I18n.is.french(this)
                ? window.open('https://cleanfox.io/blog/fox-fr/notifications-push-navigateurs/', '_blank', 'rel="noopener,noreferrer,nofollow"')
                : window.open('https://cleanfox.io/blog/fox-en/how-to-enable-push-notifications-on-chrome-firefox-and-safari-browsers/', '_blank', 'rel="noopener,noreferrer,nofollow"')

            this.close()
        }
    }

}

</script>

<style lang="scss" scoped>

.bsfn {
    &__container {
        width: 100%;
        padding: 64px 25px 120px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        color: $midnight;
        text-align: left;
        background-image: url('/img/bottomsheet/background-wood-mobile.svg');
        background-repeat: no-repeat;
        background-position-x: right;
        background-position-y: bottom;
        background-size: auto;
        @media screen and (min-width: $above-tablet-length) {
            background-image: url('/img/bottomsheet/background-wood-mobile.svg');
            padding: 80px 24px;
        }
    }

    &__img {
        width: 72px;
        object-fit: contain;
    }

    &__title {
        margin-top: 32px;
        font-size: 28px;
        font-weight: bold;
    }

    &__subtitle {
        margin-top: 14px;
        font-size: 17px;
        line-height: 1.29;
    }

    &__btn-accept {
        margin-top: 24px;
        height: 51px;
        width: initial;
        padding: 0 24px;
        font-size: 16px;
    }
}

</style>
